import { render } from "./MentionLegal.vue?vue&type=template&id=2e98d705&scoped=true"
import script from "./MentionLegal.vue?vue&type=script&lang=js"
export * from "./MentionLegal.vue?vue&type=script&lang=js"

import "./MentionLegal.vue?vue&type=style&index=0&id=2e98d705&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e98d705"]])

export default __exports__